import { useState, useEffect, useRef } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "../../FormControl";
import Select from "@mui/material/Select";
import BaseURL from "../../../utils/base-uri.json";
import axios from "../../../utils/fvAxios";
import { ToastContainer, toast } from "react-toastify";
import * as Yup from "yup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Typography, Divider } from "@mui/material";
import { TextField, TextareaAutosize, Checkbox } from "@mui/material";
const toastNotify = (message, isSuccess = true) => {
  if (isSuccess) {
    toast.success(message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  } else {
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }
};

export default function ChecklistSubSectionDialog({
  editDialogOpen,
  handleDialogClose,
  userId,
  orgId,
  checklistSectionId,
  checklistSubSectionId,
  currentSubSectionCount,
  subSections,
  isParent,
  isChild,
  parentSubSectionId: _parentSubSectionId,
  ...props
}) {
  const _subSections = subSections.filter((x) => x.id != 0);
  const [details, setDetails] = useState({});
  const [initialDetails, setInitialDetails] = useState({});
  const [isVisible, setVisible] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [hasChildSubsection, setHasChildSubsection] = useState(isChild);
  const [parentSubSectionId, setParentSubsectionId] = useState(_parentSubSectionId ?? 0);

  const checklistNameRef = useRef(null);

  useEffect(() => {
    setVisible(details.isVisible ?? true);
    setInitialDetails({
      checklistName: details.subSectionName,
      checklistNote: details.sectionNotes,
      isVisible: details.isVisible,
    });
    
    details?.checklistSubSectionId > 0  && setParentSubsectionId(details.parentId ?? 0);
    setHasChildSubsection(isChild);
  }, [details]);
  const toggleVisibility = (event) => {
    setVisible(event.target.checked);
  };
  const toggleIsChildSubsection = (event) => {
    if (event.target.checked === false) setParentSubsectionId(0);

    setHasChildSubsection(event.target.checked);
  };
  useEffect(() => {
    if (checklistSubSectionId == 0) {
      return;
    }
    axios
      .get(
        BaseURL.templateTool.GetChecklistSubSectionDetail +
          "checklistSubSectionId=" +
          checklistSubSectionId
      )
      .then((res) => {
        if (res?.data?.status == false) console.error(res?.data);
        if (res.data?.data) {
          setDetails(res.data?.data);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const validationSchema = Yup.object().shape({
    checklistName: Yup.string()
      .required("Name is required!")
      .max(200, "Name must be at most 200 characters"),
    checklistNote: Yup.string().max(
      2000,
      "Check List Sub Section Note must be at most 2000 characters"
    ),
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: initialDetails,
  });

  const onSubmit = async (data) => {
    setIsSaving(true);

    let _section = {
      checklistSubSectionId: checklistSubSectionId,
      checklistSectionId: checklistSectionId,
      subSectionName: data.checklistName,
      sectionNotes: data.checklistNote,
      IsVisible: isVisible,
      displayOrder:
        checklistSubSectionId > 0
          ? details.displayOrder
          : currentSubSectionCount + 1,
      // templateId:templateId,
      checklistQuestions: [],
      parentId: parentSubSectionId == 0 ? null : parentSubSectionId,
    };

    const response = await axios.post(
      BaseURL.templateTool.AddUpdateChecklistSubSection,
      _section
    );

    if (response.data?.responseCode >= 0) {
      if (response.data?.data) {
        toastNotify("Success", true);
        handleDialogClose(true);
        // checklistSectionId == 0 && setChecklistSectionId(+response.data?.data);
      }
    } else if (response.data?.responseCode == -100) {
      toastNotify(response.data?.responseMessage, false);
    } else if (response.data?.responseCode == -200) {
      const errorMessages = Object.entries(response.data.error).map(
        ([fieldName, messages]) => {
          return `${fieldName}: ${messages.join(", ")}`;
        }
      );

      toastNotify(errorMessages.join(" | "), false);
    } else console.error(response.data);

    setIsSaving(false);
  };
  useEffect(() => {
    reset(initialDetails);
    if (checklistNameRef.current) {
      checklistNameRef.current.focus();
    }
  }, [reset, initialDetails]);

  const handleChildSubSection = (event) => {
    setParentSubsectionId(event.target.value);
  };

  return (
    <>
      <Dialog
        open={true}
        maxWidth={"sm"}
        fullWidth={true}
        onClose={handleDialogClose}
        className="w-100 p-2"
      >
        <DialogTitle id="companyAccess-dialog-title">
          {checklistSubSectionId > 0
            ? "Edit Checklist Sub Section"
            : "Add Checklist Sub Section"}
        </DialogTitle>
        <DialogContent>
          <div className="form">
            <div className="row mt-2">
              <div className="col-md-5">
                <span className="input-label-left">
                  Name
                  <small style={{ color: "red" }}> *</small>
                </span>
              </div>
              <div className="col-md-7">
                <TextField
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  size="small"
                  required
                  id="checklistName"
                  name="checklistName"
                  placeholder="Checklist Section Name"
                  className="form-control text-feild-custom mx-2"
                  {...register("checklistName")}
                  inputRef={checklistNameRef}
                />
                <Typography className="text-danger mx-2">
                  {errors.checklistName?.message}
                </Typography>
              </div>
            </div>
            <Divider className="mt-3" />

            <div className="row mt-2">
              <div className="col-md-5">
                <span className="input-label-left">Visibility</span>
              </div>
              <div className="col-md-7">
                <FormControlLabel
                  className="ms-2"
                  control={
                    <Checkbox
                      name="isVisible"
                      id="isVisible"
                      inputProps={{ "aria-label": "controlled" }}
                      checked={isVisible}
                      onChange={toggleVisibility}
                    />
                  }
                  label={`${isVisible ? "Visible" : "Hidden"}`}
                />
              </div>

              <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
            </div>
            {/* {!isParent && (
              <>
                <Divider className="mt-3" />
                <div className="row mt-2">
                  <div className="col-md-5">
                    <span className="input-label-left">Is Sub-Sub Section</span>
                  </div>
                  <div className="col-md-7">
                    <FormControlLabel
                      className="ms-2"
                      control={
                        <Checkbox
                          name="isChildSubSection"
                          id="isChildSubSection"
                          inputProps={{ "aria-label": "controlled" }}
                          checked={hasChildSubsection}
                          onChange={toggleIsChildSubsection}
                        />
                      }
                      label=""
                    />
                  </div>
                </div>
                <Divider className="mt-3" />
                {hasChildSubsection && (
                  <div className="row mt-2">
                    <div className="col-md-5">
                      <span className="input-label-left">
                        Parent Sub Section
                      </span>
                    </div>
                    <div className="col-md-7">
                      {
                        <Select
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          value={parentSubSectionId}
                          required
                          size="small"
                          name="ParentSection"
                          id="ParentSection"
                          className="form-control text-feild-custom mx-2"
                          onChange={handleChildSubSection}
                        >
                          <MenuItem value={0}>Select</MenuItem>
                          {_subSections.map((r, index) => (
                            <MenuItem key={index} value={r.id}>
                              {r.text}
                            </MenuItem>
                          ))}
                        </Select>
                      }
                    </div>
                  </div>
                )}
              </>
            )} */}
            <Divider className="mt-3" />
            <div className="row mt-2">
              <div className="col-md-5">
                <span className="input-label-left">Notes</span>
              </div>
              <div className="col-md-7">
                <TextareaAutosize
                  minRows={3}
                  id="checklistNote"
                  name="checklistNote"
                  placeholder="Notes"
                  size="small"
                  className="form-control text-feild-custom mx-2"
                  {...register("checklistNote")}
                />
                <Typography className="text-danger mx-2">
                  {errors.checklistNote?.message}
                </Typography>
              </div>
              <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}> Cancel</Button>
          {isSaving ? (
            <Box
              style={{
                display: "flex",
                marginLeft: "auto",
                padding: "5px",
              }}
            >
              <CircularProgress size={28} />
            </Box>
          ) : (
            <Button
              variant="contained"
              onClick={handleSubmit(onSubmit)}
              style={{ marginLeft: "auto", padding: "12px" }}
            >
              Save
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <ToastContainer />
    </>
  );
}
